/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderConfirmDepositDto } from '../../models/order-confirm-deposit-dto';
import { OrderDto } from '../../models/order-dto';

export interface OrderControllerConfirmDeposit$Params {

/**
 * 주문 ID
 */
  id: string;
      body: OrderConfirmDepositDto
}

export function orderControllerConfirmDeposit(http: HttpClient, rootUrl: string, params: OrderControllerConfirmDeposit$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
  const rb = new RequestBuilder(rootUrl, orderControllerConfirmDeposit.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderDto>;
    })
  );
}

orderControllerConfirmDeposit.PATH = '/api/orders/{id}/confirm-deposit';
